// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\na[data-v-3ad4e70c] {\n  padding-right: 1em;\n  text-decoration: none;\n}\n", ""]);
// Exports
module.exports = exports;
